/**
 * Certification-program stage vocabulary — V98-0-6.
 *
 * One enum shared by <StageRail /> and <StageChip /> so a stage is never
 * spelled two ways (Contract C19). Scope → Prepare → Audit are linear;
 * once certified, Operate and Report run concurrently inside the
 * "Certified" loop until the next cycle re-enters Scope.
 */
export const CERT_STAGES = ['scope', 'prepare', 'audit', 'operate', 'report'];
/** Linear (pre-certification) stations, in order. */
export const LINEAR_STAGES = ['scope', 'prepare', 'audit'];
/** Concurrent stations inside the "Certified" loop. */
export const LOOP_STAGES = ['operate', 'report'];
export const CERT_STAGE_LABELS = {
    scope: 'Scope',
    prepare: 'Prepare',
    audit: 'Audit',
    operate: 'Operate',
    report: 'Report',
};
export function isLoopStage(stage) {
    return LOOP_STAGES.includes(stage);
}
export function isCertStage(value) {
    return typeof value === 'string' && CERT_STAGES.includes(value);
}
//# sourceMappingURL=stages.js.map